export default "__VITE_ASSET__CJpZAaau__"